import React, { useState, useEffect } from 'react';
import { Badge, Button, Form, InputGroup, Nav, Row, Col } from 'react-bootstrap';
import { oneKlicks } from '../../SDK/oneclick';
import { FaMapMarkerAlt, FaEye } from 'react-icons/fa';
import MapSearchModal from '../Components/MapSearchModal';
import ImageShow from '../../Uitiles/ImageShow';
import CryptoJS from 'crypto-js';

const Leads = () => {
    const [activeTab, setActiveTab] = useState('general');
    const [leads, setLeads] = useState([]);
    const [staffList, setStaffList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isViewModalVisible, setIsViewModalVisible] = useState(false);
    const [editingLead, setEditingLead] = useState(null);
    const [viewingLead, setViewingLead] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        hospital_name: '',
        address: '',
        location: null,
        assigned_staff_id: '',
        status: 'New',
        notes: ''
    });
    const [searchTerm, setSearchTerm] = useState('');
    const [isMapModalVisible, setIsMapModalVisible] = useState(false);

    useEffect(() => {
        fetchLeads();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab]);

    useEffect(() => {
        fetchStaff();
    }, []);

    const fetchLeads = async () => {
        try {
            const tableSchema = '';
            const tableName = activeTab === 'general' ? 'leads' : 'partner_leads';
            const conditions = {};
            const orderBy = "id DESC";
            const search = searchTerm;
            const pagination = {};
            const margedata = activeTab === 'general' ? [
                {
                    target_table: 'users',
                    target_column: 'id',
                    target_value: 'assigned_staff_id',
                    target_label: 'assigned_staff'
                }
            ] : [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (response.success) {
                setLeads(response.data);
            } else {
                console.error('Error fetching leads:', response.message);
                setLeads([]);
            }
        } catch (error) {
            console.error('Error fetching leads:', error);
            setLeads([]);
        }
    };

    const fetchStaff = async () => {
        try {
            const tableSchema = '';
            const tableName = 'users';
            const conditions = { user_type: 'staff' };
            const orderBy = "id DESC";
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, '', {}, {});
            if (response.success) {
                setStaffList(response.data);
            } else {
                console.error('Error fetching staff:', response.message);
            }
        } catch (error) {
            console.error('Error fetching staff:', error);
        }
    };

    const handleAdd = () => {
        setEditingLead(null);
        if (activeTab === 'general') {
            setFormData({
                name: '',
                phone: '',
                email: '',
                hospital_name: '',
                address: '',
                location: null,
                assigned_staff_id: '',
                status: 'New',
                notes: ''
            });
        } else {
            setFormData({
                doctor_name: '',
                qualification: '',
                specialization: '',
                clinic_name: '',
                location: '',
                latitude: '',
                longitude: '',
                appointment_contact: '',
                email: '',
                services: '',
                website: '',
                social_facebook: '',
                social_instagram: '',
                social_twitter: '',
                social_youtube: '',
                social_linkedin: '',
                social_whatsapp: '',
                social_tiktok: '',
                poster_color: '#1e88e5',
                poster_theme: '',
                status: 'pending',
                doctor_photo_ids: '[]',
                clinic_photo_ids: '[]',
                logo_id: ''
            });
        }
        setIsModalVisible(true);
    };

    const handleEdit = (record) => {
        setEditingLead(record);
        
        if (activeTab === 'general') {
            let parsedLocation = null;
            if (record.location) {
                try {
                    parsedLocation = typeof record.location === 'string' ? JSON.parse(record.location) : record.location;
                } catch (e) {
                    console.error("Error parsing location", e);
                }
            }

            setFormData({
                name: record.name || '',
                phone: record.phone || '',
                email: record.email || '',
                hospital_name: record.hospital_name || '',
                address: record.address || '',
                location: parsedLocation,
                assigned_staff_id: record.assigned_staff_id || '',
                status: record.status || 'New',
                notes: record.notes || ''
            });
        } else {
            setFormData({
                doctor_name: record.doctor_name || '',
                qualification: record.qualification || '',
                specialization: record.specialization || '',
                clinic_name: record.clinic_name || '',
                location: record.location || '',
                latitude: record.latitude || '',
                longitude: record.longitude || '',
                appointment_contact: record.appointment_contact || '',
                email: record.email || '',
                services: record.services || '',
                website: record.website || '',
                social_facebook: record.social_facebook || '',
                social_instagram: record.social_instagram || '',
                social_twitter: record.social_twitter || '',
                social_youtube: record.social_youtube || '',
                social_linkedin: record.social_linkedin || '',
                social_whatsapp: record.social_whatsapp || '',
                social_tiktok: record.social_tiktok || '',
                poster_color: record.poster_color || '#1e88e5',
                poster_theme: record.poster_theme || '',
                status: record.status || 'pending',
                doctor_photo_ids: record.doctor_photo_ids || '[]',
                clinic_photo_ids: record.clinic_photo_ids || '[]',
                logo_id: record.logo_id || ''
            });
        }
        setIsModalVisible(true);
    };

    const handleView = (record) => {
        setViewingLead(record);
        setIsViewModalVisible(true);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this lead?")) {
            try {
                const tableName = activeTab === 'general' ? 'leads' : 'partner_leads';
                const response = await oneKlicks.delete('', tableName, { id });
                if (response.success) {
                    setLeads(leads.filter(item => item.id !== id));
                    alert('Lead deleted successfully');
                } else {
                    alert('Error deleting lead: ' + response.message);
                }
            } catch (error) {
                console.error('Error deleting lead:', error);
            }
        }
    };

    const handleConvertDoctor = async (lead) => {
        if (!window.confirm("Are you sure you want to convert this lead to a doctor account?")) return;
        setSubmitLoading(true);
        try {
            const dataToSave = {
                first_name: lead.doctor_name || lead.name || '',
                last_name: '',
                email: lead.email || '',
                phone: lead.appointment_contact || lead.phone || '',
                user_type: 'doctor',
                display_name: lead.doctor_name || lead.name || '',
                status: 'active',
                address: lead.location || lead.address || '',
                location: (lead.latitude && lead.longitude) ? JSON.stringify({ lat: parseFloat(lead.latitude), lng: parseFloat(lead.longitude) }) : null,
        pass: CryptoJS.SHA256('Ravindra12@').toString()
            };

            const response = await oneKlicks.create('', 'users', dataToSave, {});
            if (response.success) {
                const tableName = activeTab === 'general' ? 'leads' : 'partner_leads';
                await oneKlicks.update('', tableName, { status: 'Converted' }, { id: lead.id });
                alert('Doctor account created successfully');
                fetchLeads();
            } else {
                alert('Error creating doctor account: ' + response.message);
            }
        } catch (error) {
            console.error('Error converting to doctor:', error);
            alert('An error occurred while converting.');
        } finally {
            setSubmitLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleLocationSelect = (locationData) => {
        setFormData(prev => ({
            ...prev,
            location: locationData.location,
            address: locationData.address
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitLoading(true);

        const tableName = activeTab === 'general' ? 'leads' : 'partner_leads';
        let dataToSave = {};

        if (activeTab === 'general') {
            dataToSave = {
                name: formData.name,
                phone: formData.phone,
                email: formData.email,
                hospital_name: formData.hospital_name,
                address: formData.address,
                location: formData.location ? JSON.stringify(formData.location) : null,
                assigned_staff_id: formData.assigned_staff_id || null,
                status: formData.status,
                notes: formData.notes
            };
        } else {
            dataToSave = {
                doctor_name: formData.doctor_name,
                qualification: formData.qualification,
                specialization: formData.specialization,
                clinic_name: formData.clinic_name,
                location: formData.location,
                latitude: formData.latitude,
                longitude: formData.longitude,
                appointment_contact: formData.appointment_contact,
                email: formData.email,
                services: formData.services,
                website: formData.website,
                social_facebook: formData.social_facebook,
                social_instagram: formData.social_instagram,
                social_twitter: formData.social_twitter,
                social_youtube: formData.social_youtube,
                social_linkedin: formData.social_linkedin,
                social_whatsapp: formData.social_whatsapp,
                social_tiktok: formData.social_tiktok,
                poster_color: formData.poster_color,
                poster_theme: formData.poster_theme,
                status: formData.status,
                doctor_photo_ids: formData.doctor_photo_ids,
                clinic_photo_ids: formData.clinic_photo_ids,
                logo_id: formData.logo_id
            };
        }

        try {
            if (editingLead) {
                const response = await oneKlicks.update('', tableName, dataToSave, { id: editingLead.id });
                if (response.success) {
                    alert('Lead updated successfully');
                    setIsModalVisible(false);
                    fetchLeads();
                } else {
                    alert('Error updating lead: ' + response.message);
                }
            } else {
                const response = await oneKlicks.create('', tableName, dataToSave, {});
                if (response.success) {
                    alert('Lead added successfully');
                    setIsModalVisible(false);
                    fetchLeads();
                } else {
                    alert('Error adding lead: ' + response.message);
                }
            }
        } catch (error) {
            console.error('Error submitting lead:', error);
            alert('An error occurred.');
        } finally {
            setSubmitLoading(false);
        }
    };

    const getStatusBadgeVariant = (status) => {
        switch (status) {
            case 'New':
            case 'pending':
                return 'info';
            case 'Contacted':
            case 'contacted':
                return 'primary';
            case 'In Progress':
                return 'warning';
            case 'Converted':
            case 'approved':
                return 'success';
            case 'Closed':
            case 'rejected':
                return 'secondary';
            default:
                return 'light';
        }
    };

    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2 mb-3">
                                <h5 className="mb-0 font-weight-bold mr-3">Leads Management</h5>
                            </div>
                            <Nav variant="pills" activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
                                <Nav.Item>
                                    <Nav.Link eventKey="general" className={activeTab === 'general' ? 'active' : ''}>General Leads</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="partner" className={activeTab === 'partner' ? 'active' : ''}>Partner Onboarding Leads</Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <InputGroup className="p-0" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                                    <Form.Control
                                        placeholder="Search leads..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        onKeyPress={(e) => e.key === 'Enter' && fetchLeads()}
                                    />
                                    <Button variant="outline-secondary" onClick={fetchLeads}>Search</Button>
                                </InputGroup>
                                <Button variant="primary" onClick={handleAdd}>
                                    {activeTab === 'general' ? '+ Add General Lead' : '+ Add Partner Lead'}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-hover table-striped">
                                <thead>
                                    {activeTab === 'general' ? (
                                        <tr>
                                            <th>ID</th>
                                            <th>Contact Name</th>
                                            <th>Phone</th>
                                            <th>Hospital Name</th>
                                            <th>Assigned Staff</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    ) : (
                                        <tr>
                                            <th>ID</th>
                                            <th>Doctor Name</th>
                                            <th>Specialization</th>
                                            <th>Clinic Name</th>
                                            <th>Phone</th>
                                            <th>Lat/Lng</th>
                                            <th>Created At</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    )}
                                </thead>
                                <tbody>
                                    {leads.length > 0 ? leads.map((lead, index) => (
                                        <tr key={lead.id}>
                                            <td data-label="ID">{index + 1}</td>
                                            {activeTab === 'general' ? (
                                                <>
                                                    <td data-label="Contact Name" style={{ whiteSpace: 'nowrap' }}>{lead.name}</td>
                                                    <td data-label="Phone">{lead.phone}</td>
                                                    <td data-label="Hospital Name">{lead.hospital_name}</td>
                                                    <td data-label="Assigned Staff">
                                                        {lead.assigned_staff && lead.assigned_staff.length > 0 
                                                            ? `${lead.assigned_staff[0].first_name} ${lead.assigned_staff[0].last_name}` 
                                                            : 'Unassigned'}
                                                    </td>
                                                </>
                                            ) : (
                                                <>
                                                    <td data-label="Doctor Name" style={{ whiteSpace: 'nowrap' }}>{lead.doctor_name}</td>
                                                    <td data-label="Specialization">{lead.specialization} ({lead.qualification})</td>
                                                    <td data-label="Clinic Name">{lead.clinic_name || 'N/A'}</td>
                                                    <td data-label="Phone">{lead.appointment_contact}</td>
                                                    <td data-label="Lat/Lng">{lead.latitude}, {lead.longitude}</td>
                                                    <td data-label="Created At">{lead.created_at ? new Date(lead.created_at).toLocaleDateString() : 'N/A'}</td>
                                                </>
                                            )}
                                            <td data-label="Status">
                                                <Badge bg={getStatusBadgeVariant(lead.status)}>{lead.status}</Badge>
                                            </td>
                                            <td data-label="Actions">
                                                <div className="d-flex gap-2 justify-content-end">
                                                    <Button variant="success" size="sm" onClick={() => handleConvertDoctor(lead)}>
                                                        Convert Doctor
                                                    </Button>
                                                    <Button variant="info" size="sm" onClick={() => handleView(lead)}>
                                                        <FaEye /> View
                                                    </Button>
                                                    <Button variant="primary" size="sm" onClick={() => handleEdit(lead)}>Edit</Button>
                                                    <Button variant="danger" size="sm" onClick={() => handleDelete(lead.id)}>Delete</Button>
                                                </div>
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan={activeTab === 'general' ? 7 : 8} className="text-center">No leads found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add / Edit Modal */}
            {isModalVisible && (
                <div className="modal-overlay">
                    <div className="modal-content" style={{ width: activeTab === 'general' ? '600px' : '800px', display: 'block !important' }}>
                        <div className="modal-header">
                            <h3>{editingLead ? 'Edit Lead' : 'Add Lead'}</h3>
                            <button
                                className="close-button"
                                onClick={() => setIsModalVisible(false)}
                                aria-label="Close"
                            >
                                ×
                            </button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            {activeTab === 'general' ? (
                                <>
                                    <div className="d-flex flex-row gap-2" style={{ gap: '10px' }}>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="name">Contact Name:</label>
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                value={formData.name || ''}
                                                onChange={handleInputChange}
                                                required
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="phone">Phone Number:</label>
                                            <input
                                                type="text"
                                                id="phone"
                                                name="phone"
                                                value={formData.phone || ''}
                                                onChange={handleInputChange}
                                                required
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label htmlFor="email">Email Address:</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email || ''}
                                            onChange={handleInputChange}
                                            className="form-control"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="hospital_name">Hospital Name:</label>
                                        <input
                                            type="text"
                                            id="hospital_name"
                                            name="hospital_name"
                                            value={formData.hospital_name || ''}
                                            onChange={handleInputChange}
                                            className="form-control"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="address">Address:</label>
                                        <div className="location-input-container d-flex">
                                            <input
                                                type="text"
                                                id="address"
                                                name="address"
                                                value={formData.address || ''}
                                                onChange={handleInputChange}
                                                placeholder="Type address or search on map"
                                                className="form-control"
                                            />
                                            <Button
                                                type="button"
                                                variant="outline-secondary"
                                                onClick={() => setIsMapModalVisible(true)}
                                                className="ml-2"
                                            >
                                                <FaMapMarkerAlt /> Map
                                            </Button>
                                        </div>
                                    </div>

                                    <div className="d-flex flex-row gap-2" style={{ gap: '10px' }}>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="assigned_staff_id">Assign Staff:</label>
                                            <select
                                                id="assigned_staff_id"
                                                name="assigned_staff_id"
                                                value={formData.assigned_staff_id || ''}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            >
                                                <option value="">-- Unassigned --</option>
                                                {staffList.map(staff => (
                                                    <option key={staff.id} value={staff.id}>
                                                        {staff.first_name} {staff.last_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="form-group flex-fill">
                                            <label htmlFor="status">Status:</label>
                                            <select
                                                id="status"
                                                name="status"
                                                value={formData.status || 'New'}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            >
                                                <option value="New">New</option>
                                                <option value="Contacted">Contacted</option>
                                                <option value="In Progress">In Progress</option>
                                                <option value="Converted">Converted</option>
                                                <option value="Closed">Closed</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="notes">Additional Notes:</label>
                                        <textarea
                                            id="notes"
                                            name="notes"
                                            value={formData.notes || ''}
                                            onChange={handleInputChange}
                                            className="form-control"
                                            rows="3"
                                        ></textarea>
                                    </div>
                                </>
                            ) : (
                                <div style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: '5px' }}>
                                    <div className="d-flex flex-row gap-2" style={{ gap: '10px' }}>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="doctor_name">Doctor Name:</label>
                                            <input
                                                type="text"
                                                id="doctor_name"
                                                name="doctor_name"
                                                value={formData.doctor_name || ''}
                                                onChange={handleInputChange}
                                                required
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="appointment_contact">Appointment Contact:</label>
                                            <input
                                                type="text"
                                                id="appointment_contact"
                                                name="appointment_contact"
                                                value={formData.appointment_contact || ''}
                                                onChange={handleInputChange}
                                                required
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <div className="d-flex flex-row gap-2" style={{ gap: '10px' }}>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="qualification">Qualification:</label>
                                            <input
                                                type="text"
                                                id="qualification"
                                                name="qualification"
                                                value={formData.qualification || ''}
                                                onChange={handleInputChange}
                                                required
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="specialization">Specialization:</label>
                                            <input
                                                type="text"
                                                id="specialization"
                                                name="specialization"
                                                value={formData.specialization || ''}
                                                onChange={handleInputChange}
                                                required
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <div className="d-flex flex-row gap-2" style={{ gap: '10px' }}>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="clinic_name">Clinic Name:</label>
                                            <input
                                                type="text"
                                                id="clinic_name"
                                                name="clinic_name"
                                                value={formData.clinic_name || ''}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="email">Email Address:</label>
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                value={formData.email || ''}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="location">Address / Location:</label>
                                        <input
                                            type="text"
                                            id="location"
                                            name="location"
                                            value={formData.location || ''}
                                            onChange={handleInputChange}
                                            className="form-control"
                                        />
                                    </div>

                                    <div className="d-flex flex-row gap-2" style={{ gap: '10px' }}>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="latitude">Latitude:</label>
                                            <input
                                                type="text"
                                                id="latitude"
                                                name="latitude"
                                                value={formData.latitude || ''}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="longitude">Longitude:</label>
                                            <input
                                                type="text"
                                                id="longitude"
                                                name="longitude"
                                                value={formData.longitude || ''}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="services">Services:</label>
                                        <textarea
                                            id="services"
                                            name="services"
                                            value={formData.services || ''}
                                            onChange={handleInputChange}
                                            className="form-control"
                                            rows="2"
                                        ></textarea>
                                    </div>

                                    <div className="d-flex flex-row gap-2" style={{ gap: '10px' }}>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="website">Website:</label>
                                            <input
                                                type="text"
                                                id="website"
                                                name="website"
                                                value={formData.website || ''}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="status">Status:</label>
                                            <select
                                                id="status"
                                                name="status"
                                                value={formData.status || 'pending'}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            >
                                                <option value="pending">Pending</option>
                                                <option value="approved">Approved</option>
                                                <option value="contacted">Contacted</option>
                                                <option value="rejected">Rejected</option>
                                            </select>
                                        </div>
                                    </div>

                                    <h6 className="mt-3 border-bottom pb-2">Branding & Theme</h6>
                                    <div className="d-flex flex-row gap-2" style={{ gap: '10px' }}>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="poster_theme">Poster Theme:</label>
                                            <select
                                                id="poster_theme"
                                                name="poster_theme"
                                                value={formData.poster_theme || ''}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            >
                                                <option value="">None</option>
                                                <option value="professional">Professional Blue</option>
                                                <option value="warm">Warm & Friendly</option>
                                                <option value="nature">Nature & Wellness</option>
                                                <option value="elegant">Dark Elegant</option>
                                                <option value="vibrant">Vibrant & Modern</option>
                                                <option value="minimal">Minimal White</option>
                                            </select>
                                        </div>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="poster_color">Poster Color:</label>
                                            <div className="d-flex gap-2">
                                                <input
                                                    type="color"
                                                    id="poster_color"
                                                    name="poster_color"
                                                    value={formData.poster_color || '#1e88e5'}
                                                    onChange={handleInputChange}
                                                    style={{ width: '45px', height: '38px', padding: '2px', border: '1px solid #ccc', borderRadius: '4px' }}
                                                />
                                                <input
                                                    type="text"
                                                    name="poster_color"
                                                    value={formData.poster_color || '#1e88e5'}
                                                    onChange={handleInputChange}
                                                    className="form-control"
                                                    placeholder="#ffffff"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <h6 className="mt-3 border-bottom pb-2">Social Presence</h6>
                                    <div className="d-flex flex-row gap-2" style={{ gap: '10px' }}>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="social_facebook">Facebook Link:</label>
                                            <input
                                                type="text"
                                                id="social_facebook"
                                                name="social_facebook"
                                                value={formData.social_facebook || ''}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="social_instagram">Instagram Link:</label>
                                            <input
                                                type="text"
                                                id="social_instagram"
                                                name="social_instagram"
                                                value={formData.social_instagram || ''}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex flex-row gap-2" style={{ gap: '10px' }}>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="social_twitter">Twitter Link:</label>
                                            <input
                                                type="text"
                                                id="social_twitter"
                                                name="social_twitter"
                                                value={formData.social_twitter || ''}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="social_youtube">YouTube Link:</label>
                                            <input
                                                type="text"
                                                id="social_youtube"
                                                name="social_youtube"
                                                value={formData.social_youtube || ''}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex flex-row gap-2" style={{ gap: '10px' }}>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="social_linkedin">LinkedIn Link:</label>
                                            <input
                                                type="text"
                                                id="social_linkedin"
                                                name="social_linkedin"
                                                value={formData.social_linkedin || ''}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="social_whatsapp">WhatsApp Number:</label>
                                            <input
                                                type="text"
                                                id="social_whatsapp"
                                                name="social_whatsapp"
                                                value={formData.social_whatsapp || ''}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <div className="d-flex flex-row gap-2" style={{ gap: '10px' }}>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="social_tiktok">TikTok Link:</label>
                                            <input
                                                type="text"
                                                id="social_tiktok"
                                                name="social_tiktok"
                                                value={formData.social_tiktok || ''}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group flex-fill"></div>
                                    </div>

                                    <h6 className="mt-3 border-bottom pb-2">Media Asset IDs</h6>
                                    <div className="form-group">
                                        <label htmlFor="logo_id">Logo File ID:</label>
                                        <input
                                            type="text"
                                            id="logo_id"
                                            name="logo_id"
                                            value={formData.logo_id || ''}
                                            onChange={handleInputChange}
                                            className="form-control"
                                            placeholder="e.g. 12345"
                                        />
                                    </div>
                                    <div className="d-flex flex-row gap-2" style={{ gap: '10px' }}>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="doctor_photo_ids">Doctor Photo IDs (JSON Array):</label>
                                            <input
                                                type="text"
                                                id="doctor_photo_ids"
                                                name="doctor_photo_ids"
                                                value={formData.doctor_photo_ids || '[]'}
                                                onChange={handleInputChange}
                                                className="form-control"
                                                placeholder='e.g. ["id1", "id2"]'
                                            />
                                        </div>
                                        <div className="form-group flex-fill">
                                            <label htmlFor="clinic_photo_ids">Clinic Photo IDs (JSON Array):</label>
                                            <input
                                                type="text"
                                                id="clinic_photo_ids"
                                                name="clinic_photo_ids"
                                                value={formData.clinic_photo_ids || '[]'}
                                                onChange={handleInputChange}
                                                className="form-control"
                                                placeholder='e.g. ["id1", "id2"]'
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="modal-footer" style={{ padding: '15px 0px' }}>
                                <div className="button-group">
                                    <button type="submit" className="btn btn-primary mr-2" disabled={submitLoading}>
                                        {submitLoading ? 'Submitting...' : (editingLead ? 'Update Lead' : 'Add Lead')}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => setIsModalVisible(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* View Modal */}
            {isViewModalVisible && viewingLead && (
                <div className="modal-overlay">
                    <div className="modal-content" style={{ width: activeTab === 'general' ? '500px' : '800px', display: 'block !important' }}>
                        <div className="modal-header">
                            <h3>Lead Details</h3>
                            <button
                                className="close-button"
                                onClick={() => setIsViewModalVisible(false)}
                                aria-label="Close"
                            >
                                ×
                            </button>
                        </div>
                        {activeTab === 'general' ? (
                            <div className="modal-body p-4">
                                <p><strong>Contact Name:</strong> {viewingLead.name}</p>
                                <p><strong>Phone:</strong> {viewingLead.phone}</p>
                                <p><strong>Email:</strong> {viewingLead.email || 'N/A'}</p>
                                <p><strong>Hospital Name:</strong> {viewingLead.hospital_name || 'N/A'}</p>
                                <p><strong>Address:</strong> {viewingLead.address || 'N/A'}</p>
                                <p><strong>Assigned Staff:</strong> {
                                    viewingLead.assigned_staff && viewingLead.assigned_staff.length > 0 
                                        ? `${viewingLead.assigned_staff[0].first_name} ${viewingLead.assigned_staff[0].last_name}` 
                                        : 'Unassigned'
                                }</p>
                                <p>
                                    <strong>Status:</strong> <Badge bg={getStatusBadgeVariant(viewingLead.status)}>{viewingLead.status}</Badge>
                                </p>
                                {viewingLead.notes && (
                                    <div>
                                        <strong>Notes:</strong>
                                        <p className="mt-1 p-2 bg-light border rounded">{viewingLead.notes}</p>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="modal-body p-4" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                <Row>
                                    <Col md={6}>
                                        <h5 className="border-bottom pb-2 mb-3 text-primary">Doctor Information</h5>
                                        <p><strong>Doctor Name:</strong> {viewingLead.doctor_name}</p>
                                        <p><strong>Qualification:</strong> {viewingLead.qualification}</p>
                                        <p><strong>Specialization:</strong> {viewingLead.specialization}</p>
                                    </Col>
                                    <Col md={6}>
                                        <h5 className="border-bottom pb-2 mb-3 text-primary">Clinic Information</h5>
                                        <p><strong>Clinic Name:</strong> {viewingLead.clinic_name || 'N/A'}</p>
                                        <p><strong>Services:</strong> {viewingLead.services || 'N/A'}</p>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md={6}>
                                        <h5 className="border-bottom pb-2 mb-3 text-primary">Contact & Online Details</h5>
                                        <p><strong>Phone:</strong> {viewingLead.appointment_contact}</p>
                                        <p><strong>Email:</strong> {viewingLead.email || 'N/A'}</p>
                                        <p><strong>Website:</strong> {viewingLead.website ? <a href={viewingLead.website} target="_blank" rel="noopener noreferrer">{viewingLead.website}</a> : 'N/A'}</p>
                                    </Col>
                                    <Col md={6}>
                                        <h5 className="border-bottom pb-2 mb-3 text-primary">Location</h5>
                                        <p><strong>Address:</strong> {viewingLead.location || 'N/A'}</p>
                                        <p><strong>Coordinates:</strong> {viewingLead.latitude && viewingLead.longitude ? `${viewingLead.latitude}, ${viewingLead.longitude}` : 'N/A'}</p>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md={6}>
                                        <h5 className="border-bottom pb-2 mb-3 text-primary">Branding & Settings</h5>
                                        <p><strong>Poster Theme:</strong> {viewingLead.poster_theme || 'N/A'}</p>
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                            <strong>Poster Color:</strong>
                                            <div style={{
                                                width: '24px',
                                                height: '24px',
                                                borderRadius: '4px',
                                                backgroundColor: viewingLead.poster_color || '#1e88e5',
                                                border: '1px solid #ccc',
                                                display: 'inline-block'
                                            }}></div>
                                            <span>{viewingLead.poster_color || '#1e88e5'}</span>
                                        </div>
                                        <p>
                                            <strong>Status:</strong> <Badge bg={getStatusBadgeVariant(viewingLead.status)}>{viewingLead.status}</Badge>
                                        </p>
                                    </Col>
                                    <Col md={6}>
                                        <h5 className="border-bottom pb-2 mb-3 text-primary">Social Presence</h5>
                                        <div className="d-flex flex-wrap gap-2">
                                            {viewingLead.social_facebook && <a href={viewingLead.social_facebook} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary">Facebook</a>}
                                            {viewingLead.social_instagram && <a href={viewingLead.social_instagram} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-danger">Instagram</a>}
                                            {viewingLead.social_twitter && <a href={viewingLead.social_twitter} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-dark">Twitter/X</a>}
                                            {viewingLead.social_youtube && <a href={viewingLead.social_youtube} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-danger">YouTube</a>}
                                            {viewingLead.social_linkedin && <a href={viewingLead.social_linkedin} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary">LinkedIn</a>}
                                            {viewingLead.social_whatsapp && <a href={`https://wa.me/${viewingLead.social_whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-success">WhatsApp</a>}
                                            {viewingLead.social_tiktok && <a href={viewingLead.social_tiktok} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-secondary">TikTok</a>}
                                            {!viewingLead.social_facebook && !viewingLead.social_instagram && !viewingLead.social_twitter && !viewingLead.social_youtube && !viewingLead.social_linkedin && !viewingLead.social_whatsapp && !viewingLead.social_tiktok && <span>None linked</span>}
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md={12}>
                                        <h5 className="border-bottom pb-2 mb-3 text-primary">Uploaded Assets</h5>
                                        <div className="d-flex flex-wrap gap-4 mt-2">
                                            {viewingLead.logo_id && (
                                                <div className="text-center">
                                                    <h6>Clinic Logo</h6>
                                                    <ImageShow image={viewingLead.logo_id} width={100} height={100} style={{ borderRadius: '8px', border: '1px solid #ddd', objectFit: 'cover' }} />
                                                </div>
                                            )}
                                            {(() => {
                                                const parsePhotoIds = (photoIdsField) => {
                                                    if (!photoIdsField) return [];
                                                    try {
                                                        const parsed = typeof photoIdsField === 'string' ? JSON.parse(photoIdsField) : photoIdsField;
                                                        return Array.isArray(parsed) ? parsed : [parsed];
                                                    } catch (e) {
                                                        if (typeof photoIdsField === 'string') {
                                                            if (photoIdsField.startsWith('[')) return [];
                                                            return photoIdsField.split(',').map(s => s.trim()).filter(Boolean);
                                                        }
                                                        return [];
                                                    }
                                                };
                                                const docPhotos = parsePhotoIds(viewingLead.doctor_photo_ids);
                                                const clinicPhotos = parsePhotoIds(viewingLead.clinic_photo_ids);
                                                return (
                                                    <>
                                                        {docPhotos.length > 0 && (
                                                            <div>
                                                                <h6>Doctor Photos</h6>
                                                                <div className="d-flex gap-2 flex-wrap">
                                                                    {docPhotos.map((id, index) => (
                                                                        <ImageShow key={index} image={id} width={100} height={100} style={{ borderRadius: '8px', border: '1px solid #ddd', objectFit: 'cover' }} />
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {clinicPhotos.length > 0 && (
                                                            <div>
                                                                <h6>Clinic Photos</h6>
                                                                <div className="d-flex gap-2 flex-wrap">
                                                                    {clinicPhotos.map((id, index) => (
                                                                        <ImageShow key={index} image={id} width={100} height={100} style={{ borderRadius: '8px', border: '1px solid #ddd', objectFit: 'cover' }} />
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {!viewingLead.logo_id && docPhotos.length === 0 && clinicPhotos.length === 0 && (
                                                            <span>No photos uploaded.</span>
                                                        )}
                                                    </>
                                                );
                                            })()}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        )}
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setIsViewModalVisible(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            <MapSearchModal
                isVisible={isMapModalVisible}
                onClose={() => setIsMapModalVisible(false)}
                onLocationSelect={handleLocationSelect}
                initialLocation={formData.location}
            />
        </div>
    );
};

export default Leads;
